import * as React from 'react';

const MobileDrawerContext = React.createContext(null);

export function MobileDrawerProvider({ children }) {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = React.useCallback(
    (newOpen) => () => setOpen(newOpen),
    [],
  );

  const value = React.useMemo(
    () => ({ open, setOpen, toggleDrawer }),
    [open, toggleDrawer],
  );

  return (
    <MobileDrawerContext.Provider value={value}>
      {children}
    </MobileDrawerContext.Provider>
  );
}

export function useMobileDrawer() {
  const context = React.useContext(MobileDrawerContext);
  if (!context) {
    throw new Error('useMobileDrawer must be used within MobileDrawerProvider');
  }
  return context;
}
